// extracted by mini-css-extract-plugin
export default {"searchPanel":"SearchPanel_searchPanel__gtrD2","inputContainer":"SearchPanel_inputContainer__6jHUV","backButton":"SearchPanel_backButton__uT8X1"};